import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { getFirestore,  collection,  addDoc,  doc,  runTransaction } from "firebase/firestore";
import SapakimHead from "../Sapakim/SapakimHead";
import Loading from "../Components/Loading";
import { FaTrash } from "react-icons/fa";

const storage = getStorage();
const firestore = getFirestore();

const woodTypes = [
  "עץ סנדוויץ בירש + עץ מלא (T25*) רמת''ג (A+)",
  "עץ סנדוויץ אקומי + עץ מלא (T25*) רמת''ג (A)",
  "עץ אמ די אף + עץ מלא (T25*) רמת''ג (B)",
  "עץ סנדוויץ תעשיתי + עץ מלא (פיני 5) רמת''ג (C)",
];
const woodType2 = ["עץ סנדוויץ + אמ די אף", "אמ די אף", "סיבית"];
const fabricManufacturers = ["Erotex", "Rafael", "Select", "אחרת אנא הוסיפו זאת בהערות"];

const shapeOptions = [
  {
    id: "shape1",
    label: "צורה 1",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%205.png?alt=media&token=70e80504-fab2-4ec5-9a9f-51e61e5706b1",
  },
  {
    id: "shape2",
    label: "צורה 2",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%203.png?alt=media&token=5638ac02-373b-4b91-a740-0228218bcbd5",
  },
  {
    id: "shape3",
    label: "צורה 3",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%206.png?alt=media&token=2aa046fc-1ea7-456f-b1ee-8bb9a10f6f0d",
  },
  {
    id: "shape4",
    label: "צורה 4",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%204.png?alt=media&token=ec668c4e-115d-4c11-810d-6d6291ca7f79",
  },
  {
    id: "shape5",
    label: "צורה 5",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%207.png?alt=media&token=de5a110b-52ee-46c1-8625-2a4cd39a7988",
  },
  {
    id: "shape6",
    label: "צורה 6",
    img: "https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FFrame%208.png?alt=media&token=f5a00fb5-87b1-4f3c-8b5f-0c3d30105680",
  },
];

const removeUndefined = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));
};

const generateSequentialOrderNumber = async () => {
  const counterRef = doc(firestore, "Metadata", "orderCounter");
  return await runTransaction(firestore, async (transaction) => {
    const counterDoc = await transaction.get(counterRef);
    let currentNumber = 500499;

    if (counterDoc.exists()) {
      currentNumber = counterDoc.data().lastOrderNumber || 500499;
    }

    const newOrderNumber = currentNumber + 1;
    transaction.set(counterRef, { lastOrderNumber: newOrderNumber }, { merge: true });

    return newOrderNumber.toString().padStart(10, "0");
  });
};

function SCreateNewQuotation() {
  const { UID, CDID } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isValidOrder, setIsValidOrder] = useState(false);
  const nav = useNavigate();

  const getMinDeliveryDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 14);
    return date.toISOString().split("T")[0];
  };

  const addNewItem = () => {
    setItems([
      ...items,
      {
        id: uuidv4(),
        name: "",
        description: "",
        type: "Upholsterer",
        fabricCode: "",
        fabricManufacturer: "",
        woodType: "",
        width: "",
        width2: "",
        width3: "",
        height: "",
        depth: "",
        notes: "",
        shape: null,
        shapeUrl: null,
        imageFiles: [],
        deliveryDate: getMinDeliveryDate(),
      },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];

    if (field === "shape") {
      const selectedShape = shapeOptions.find((s) => s.id === value);
      updatedItems[index].shape = value;
      updatedItems[index].shapeUrl = selectedShape?.img || null;

      if (value !== "shape5") updatedItems[index].width3 = "";
      if (value === "shape6") updatedItems[index].width2 = "";
    } else {
      updatedItems[index][field] = value;
    }

    setItems(updatedItems);
    const isValid = updatedItems.some((item) => item.name?.trim() && item.description?.trim());
    setIsValidOrder(isValid);
  };

  const handleImageUpload = (index, files) => {
    const updatedItems = [...items];
    const existingFiles = updatedItems[index].imageFiles || [];
    const newFiles = Array.from(files);
    updatedItems[index].imageFiles = [...existingFiles, ...newFiles];
    setItems(updatedItems);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const removeImage = (itemIndex, imageIndex) => {
    const updatedItems = [...items];
    updatedItems[itemIndex].imageFiles = updatedItems[itemIndex].imageFiles.filter(
      (_, i) => i !== imageIndex
    );
    setItems(updatedItems);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const orderNumber = await generateSequentialOrderNumber();
      const uploadedItems = [];

      for (const item of items) {
        if (!item.name.trim() || !item.description.trim()) {
          alert("כל פריט חייב לכלול שם ותיאור.");
          setLoading(false);
          return;
        }

        const imageUrls = await Promise.all(
          item.imageFiles.map(async (file) => {
            const imageRef = ref(storage, `Orders/${orderNumber}/${uuidv4()}`);
            await uploadBytes(imageRef, file);
            return getDownloadURL(imageRef);
          })
        );

        uploadedItems.push(
          removeUndefined({
            name: item.name,
            description: item.description,
            type: item.type,
            fabricCode: item.fabricCode,
            fabricManufacturer: item.fabricManufacturer,
            woodType: item.woodType,
            width: item.width,
            width2: item.width2,
            width3: item.width3,
            height: item.height,
            depth: item.depth,
            notes: item.notes,
            shape: item.shape,
            shapeUrl: item.shapeUrl,
            images: imageUrls,
            deliveryDate: item.deliveryDate,
          })
        );
      }

      const orderData = removeUndefined({
        orderNumber,
        SapakId: UID,
        CustomerID: CDID,
        items: uploadedItems,
        createdAt: new Date(),
        Status: "ממתין לאישור",
        QStatus: "pending",
      });

      await addDoc(collection(firestore, "Quotations"), orderData);
      nav(-1);
    } catch (error) {
      console.error("שגיאה בשליחת ההזמנה:", error);
      alert("שגיאה בשליחת ההזמנה: " + error.message);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <SapakimHead />
      <div className="order-form-container" dir="rtl">
        <h1>בקשת הצעת מחיר חדשה</h1>

        {items.map((item, index) => (
          <div key={item.id} className="order-item-form">
            <input
              placeholder="שם המוצר"
              value={item.name}
              onChange={(e) => handleItemChange(index, "name", e.target.value)}
            />
            <textarea
              placeholder="תיאור"
              value={item.description}
              onChange={(e) => handleItemChange(index, "description", e.target.value)}
            />
            <select
              value={item.type}
              onChange={(e) => handleItemChange(index, "type", e.target.value)}
            >
              <option value="Upholsterer">ריפוד</option>
              <option value="Carpentry">נגרות</option>
            </select>

            {item.type === "Upholsterer" && (
              <>
                <input
                  placeholder="קוד בד"
                  value={item.fabricCode}
                  onChange={(e) => handleItemChange(index, "fabricCode", e.target.value)}
                />
                <select
                  value={item.fabricManufacturer}
                  onChange={(e) => handleItemChange(index, "fabricManufacturer", e.target.value)}
                >
                  <option value="">בחר חברת בד</option>
                  {fabricManufacturers.map((m, i) => (
                    <option key={i} value={m}>{m}</option>
                  ))}
                </select>
                <select
                  value={item.woodType}
                  onChange={(e) => handleItemChange(index, "woodType", e.target.value)}
                >
                  <option value="">בחר סוג עץ</option>
                  {woodTypes.map((wood, i) => (
                    <option key={i} value={wood} disabled={i === 3}>{wood}</option>
                  ))}
                </select>

                <div className="shape-selector">
                  <p>בחר צורה:</p>
                  <div className="shapes-grid">
                    {shapeOptions.map((shape) => (
                      <div
                        key={shape.id}
                        className={`shape-option ${item.shape === shape.id ? "selected" : ""}`}
                        onClick={() => handleItemChange(index, "shape", shape.id)}
                      >
                        <img src={shape.img} alt={shape.label} className="shape-image" />
                      </div>
                    ))}
                  </div>
                </div>

                {item.shape && (
                  <>
                    <input
                      type="number"
                      placeholder="רוחב 1 (ס\\מ)"
                      value={item.width}
                      onChange={(e) => handleItemChange(index, "width", e.target.value)}
                    />
                    {item.shape === "shape5" && (
                      <>
                        <input
                          type="number"
                          placeholder="רוחב 2 (ס\\מ)"
                          value={item.width2}
                          onChange={(e) => handleItemChange(index, "width2", e.target.value)}
                        />
                        <input
                          type="number"
                          placeholder="רוחב 3 (ס\\מ)"
                          value={item.width3}
                          onChange={(e) => handleItemChange(index, "width3", e.target.value)}
                        />
                      </>
                    )}
                    {item.shape !== "shape5" && item.shape !== "shape6" && (
                      <input
                        type="number"
                        placeholder="רוחב 2 (ס\\מ)"
                        value={item.width2}
                        onChange={(e) => handleItemChange(index, "width2", e.target.value)}
                      />
                    )}
                    <input
                      type="number"
                      placeholder="עומק (ס\\מ)"
                      value={item.depth}
                      onChange={(e) => handleItemChange(index, "depth", e.target.value)}
                    />
                  </>
                )}
              </>
            )}

            {item.type === "Carpentry" && (
              <>
                <select
                  value={item.woodType}
                  onChange={(e) => handleItemChange(index, "woodType", e.target.value)}
                >
                  <option value="">בחר סוג עץ</option>
                  {woodType2.map((wood, i) => (
                    <option key={i} value={wood}>{wood}</option>
                  ))}
                </select>
                <input
                  type="number"
                  placeholder="רוחב (ס\\מ)"
                  value={item.width}
                  onChange={(e) => handleItemChange(index, "width", e.target.value)}
                />
                <input
                  type="number"
                  placeholder="גובה (ס\\מ)"
                  value={item.height}
                  onChange={(e) => handleItemChange(index, "height", e.target.value)}
                />
                <input
                  type="number"
                  placeholder="עומק (ס\\מ)"
                  value={item.depth}
                  onChange={(e) => handleItemChange(index, "depth", e.target.value)}
                />
              </>
            )}

            <textarea
              placeholder="הערות"
              value={item.notes}
              onChange={(e) => handleItemChange(index, "notes", e.target.value)}
            />

            <label>תאריך אספקה:</label>
            <input
              type="date"
              min={getMinDeliveryDate()}
              value={item.deliveryDate}
              onChange={(e) => handleItemChange(index, "deliveryDate", e.target.value)}
            />

            <input type="file" multiple onChange={(e) => handleImageUpload(index, e.target.files)} />
            {item.imageFiles.length > 0 && (
              <div className="image-preview">
                {item.imageFiles.map((file, i) => (
                  <div key={i} className="image-container">
                    <img src={URL.createObjectURL(file)} alt="תצוגה מקדימה" />
                    <button onClick={() => removeImage(index, i)} className="remove-image-btn">
                      <FaTrash color="#fff" size={15} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button onClick={() => removeItem(index)} className="remove-item-btn">
              הסר פריט
            </button>
          </div>
        ))}

        <button onClick={addNewItem} className="add-item-btn">
          הוסף פריט
        </button>

        {isValidOrder && (
          <button onClick={handleSubmit} className="submit-btn">
            שלח הצעת מחיר
          </button>
        )}
      </div>
    </>
  );
}

export default SCreateNewQuotation;
